import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    // Log to console for debugging in Android WebView
    if ((window as any).Capacitor) {
      console.error("Capacitor Error:", error.message);
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="fixed inset-0 bg-red-50 flex flex-col items-center justify-center p-4 z-[99999]">
          <h1 className="text-xl font-bold text-red-600 mb-2">Erro ao carregar o app</h1>
          <p className="text-sm text-red-500 mb-4 text-center">
            {this.state.error?.message || "Erro desconhecido"}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded-lg"
          >
            Recarregar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
